import * as React from "react";
import { Field } from "formik";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Select } from "components/common";
import { DEFAULT_FORMAT, REPORT_FORMATS_SHORT } from "report/types";
const StyledSelect = styled(Select)`
  width: 120px;
  margin-bottom: 15px;
`;
const FormatSelect = ({ disabled }) => {
  const { t } = useTranslation("enterprise_report");
  return /* @__PURE__ */ React.createElement(Field, { name: "layout.format" }, ({ field: { name, value, onChange } }) => /* @__PURE__ */ React.createElement(
    StyledSelect,
    {
      inputId: "report-format-select",
      className: "report-format-select",
      onChange: (newValue) => onChange({ target: { name, value: newValue } }),
      value: value != null ? value : DEFAULT_FORMAT,
      placeholder: t("format_select.placeholder"),
      clearable: false,
      options: REPORT_FORMATS_SHORT,
      disabled
    }
  ));
};
export default FormatSelect;
